module.exports = __webpack_public_path__ + "media/images/application/pub/image-pub-newsletter-69c7f5f6221631ff32c7e46874501236.svg";